import React, { useState } from "react";
import useLicenseMutation from "license/hooks/useLicenseMutation";
import { Button, ButtonToolbar } from "components/bootstrap";
import { ConfirmDialog } from "components/common";
import useSelectedEntities from "components/common/EntityDataTable/hooks/useSelectedEntities";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
const LicenseActions = ({ id, licenseId = void 0, contractId = void 0 }) => {
  const { deselectEntity } = useSelectedEntities();
  const { deleteLicense } = useLicenseMutation();
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const sendTelemetry = useSendTelemetry("license");
  const cancelDelete = () => {
    setShowDeleteDialog(false);
    deselectEntity(id);
  };
  const handleDelete = () => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.LICENSE.DELETED, {
      app_pathname: "license"
    });
    deleteLicense({ licenseId, contractId }).then(() => {
      deselectEntity(id);
      setShowDeleteDialog(false);
    });
  };
  const onDelete = () => {
    setShowDeleteDialog(true);
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, showDeleteDialog && /* @__PURE__ */ React.createElement(
    ConfirmDialog,
    {
      show: showDeleteDialog,
      title: "Deleting license",
      onCancel: cancelDelete,
      onConfirm: handleDelete
    },
    /* @__PURE__ */ React.createElement("p", null, 'You are about to delete the license: "', licenseId != null ? licenseId : contractId, '". Are you sure?')
  ), /* @__PURE__ */ React.createElement(ButtonToolbar, null, /* @__PURE__ */ React.createElement(Button, { bsSize: "xs", bsStyle: "danger", onClick: onDelete }, "Delete")));
};
export default LicenseActions;
